import React from "react";
import {Button, Spinner,} from "reactstrap";


const ButtonWithSpinner = (
    {
        title,
        type,
        loading,
        disabled
    }
) => {
    return <Button type={type} color="primary" size="lg"
            className="btn-wide btn-pill btn-shadow btn-hover-shine position-relative" disabled={disabled || loading}>
        <div className={`${loading ? 'd-flex' : 'd-none'} position-absolute`} style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <Spinner color="light" size="sm">
                Loading...
            </Spinner>
        </div>
        <span style={{opacity: loading ? 0 : 1}}>{title}</span>
    </Button>
};


export default ButtonWithSpinner;